import { config } from '../../config/Config';
import { displayComponents } from './VisorsUtils';
import GeoJSON from 'ol/format/GeoJSON';

export async function fetchAndProcessData(urls, bbox, clickPixel, taulaFullFilter) {
  const fetchUrls = getInfoPuntUrls(urls, bbox, clickPixel, taulaFullFilter);

  let responses = [];

  for (const { url, body } of fetchUrls) {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(body).toString()
    });
    const responseText = await response.text();

    const geoJsonFormat = new GeoJSON();
    const crs = geoJsonFormat.readProjection(responseText).getCode();
    const features = geoJsonFormat.readFeatures(responseText, {
      dataProjection: crs,
      featureProjection: config.EPSG_mapa
    });
    responses = responses.concat(features);
  }
  return responses;
}

export const getInfoPuntUrls = (array, bbox, clickPixel, taulaFullFilter) => {
  let urls = [];
  const type = 'application/json';
  array.forEach((onlineResource) => {
    let layersList = '';
    let url = '';
    let filterList = '';
    let styles = '';

    for (const key in onlineResource) {
      url = key;
      const layers = onlineResource[key];
      let filters = [];

      for (let i = 0; i < layers.length; i++) {
        // Construir layersList
        if (!layers[i].isExternal() && layers[i].getName()) {
          layersList += layersList === '' ? layers[i].getName() : ',' + layers[i].getName();
        }

        // Construir filterList
        const layerTitle = layers[i].getTitle();
        let layerFilter = taulaFullFilter[layerTitle];

        if (layerFilter) {
          filters.push(layerFilter.replaceAll('%25', '%'));
        } else {
          filters.push('INCLUDE');
        }
        // Construir styles
        const styleName = layers[i].getStyle(layers[i].getStyleSelected()).getName();
        styles += styles === '' ? styleName : ',' + styleName;
      }

      filterList = filters.join(';');
    }

    let buffer = 5;
    if (window.innerWidth <= 768) buffer = 15;
    let height = displayComponents.navbar
      ? window.innerWidth < 768
        ? parseInt(Math.trunc(window.innerHeight) - 80).toString()
        : parseInt(Math.trunc(window.innerHeight) - 40).toString()
      : parseInt(Math.trunc(window.innerHeight)).toString();

    const body = {
      LAYERS: layersList,
      QUERY_LAYERS: layersList,
      STYLES: styles,
      SERVICE: 'WMS',
      VERSION: config.capabilities_version,
      REQUEST: 'GetFeatureInfo',
      BBOX: bbox,
      FEATURE_COUNT: Math.floor(60 / array.length),
      HEIGHT: height,
      WIDTH: parseInt(Math.trunc(window.innerWidth)).toString(),
      FORMAT: 'image/png',
      INFO_FORMAT: type,
      CRS: config.EPSG_mapa,
      X: clickPixel[0],
      Y: clickPixel[1],
      buffer: buffer
    };

    if (filterList) {
      body.CQL_FILTER = filterList;
    }

    urls.push({ url, body });
  });
  return urls;
};
